import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import AccountView from '../views/AccountView.vue'
import PoolSettingsView from '../views/PoolSettingsView.vue'
import MatchView from "../views/MatchView.vue";
import PlaceholderView from "../views/PlaceholderView.vue";
import LogOverview from "../views/LogOverview.vue";
import DrinksView from '../views/DrinksView.vue'
import HGameView from '../views/HGameView.vue'
import DashboardView from '../views/DashboardView.vue'
import TermsOfServiceView from '../views/TermsOfServiceView.vue'
import WithdrawalView from '../views/WithdrawalView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue'
import WrappedView from '../views/WrappedView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { depth: 0 }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView,
    meta: { depth: 0 }
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: TermsOfServiceView,
    meta: { depth: 99 }
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: WithdrawalView,
    meta: { depth: 99 }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { depth: 1 }
  },
  {
    path: '/account',
    name: 'account',
    component: AccountView,
    meta: { depth: 6 }
  },
  {
    path: '/wrapped',
    name: 'wrapped',
    component: WrappedView,
    meta: { depth: 10 }
  },
  {
    path: '/pool-settings',
    name: 'pool-settings',
    component: PoolSettingsView,
    meta: { depth: 2 }
  },
  {
    path: '/match',
    name: 'match',
    component: MatchView,
    meta: { depth: 1 }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { depth: 3 }
  },
  {
    path: '/placeholder',
    name: 'placeholder',
    component: PlaceholderView,
    meta: { depth: 99 }
  },
  {
    path: '/log-overview',
    name: 'log-overview',
    component: LogOverview,
    meta: { depth: 4 }
  },
  {
    path: '/drinks',
    name: 'drinks',
    component: DrinksView,
    meta: { depth: 5 }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView,
    meta: { depth: 99 }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminDashboardView,
    meta: { depth: 7 }
  },
  {
    path: '/join/:code',
    name: 'join',
    component: () => import('../views/JoinView.vue'),
    meta: { depth: 0 }
  },
  {
    path: '/h-game',
    name: 'h-game',
    component: HGameView,
    meta: { depth: 5 }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
